<div class="drawer-container" appTrapFocus>
  <div
    #dialogContent
    role="dialog"
    aria-modal="true"
    class="drawer-content"
    data-testid="drawer-content"
    [id]="'qa-' + id"
    [attr.aria-labelledby]="'qa-drawer-title' + id"
    [attr.aria-describedby]="'qa-drawer-description' + id"
    [class.drawer-content--full]="isMobileAndFullscreen"
    [ngStyle]="{ bottom: bottomPositionStyle }"
    (scroll)="setScrollPosition($event)"
  >
    <app-drawer-header
      [modalId]="id"
      [title]="title"
      [shouldShowHeaderBorder]="shouldShowHeaderBorder"
      [shouldShowSwiper]="shouldShowSwiper"
      (onHeaderSwipeDown)="swipeDown($event)"
      (onModalClose)="close()"
      (onPanEnd)="panEnd()"
    />

    <div class="drawer-body" [id]="'qa-drawer-description-' + id">
      <ng-content></ng-content>
    </div>

    <ng-content select="[footer]"></ng-content>

    <!-- Supporting Accessibility -->
    <div *ngIf="shouldShowBottomCloseButton" class="drawer-close-container">
      <button type="button" sparkButton variant="primary" (click)="close()">{{ closeBottomBtnTitle }}</button>
    </div>
  </div>
</div>
